export function rateTypeLabel(rateType: string | null | undefined): string {
  return rateType === 'daily' ? 'Day rate' : 'Hourly';
}
